const ROUTES = {
  login: '/:lang/login',
  recovery: '/:lang/recovery',
  linkSent: '/:lang/recovery/link-sent',
  linkConfirm: '/:lang/password_recovery',
  setNewPass: '/:lang/new-password',
  confirmAsanImza: '/:lang/authorization/confirm-asan-imza',
  otp: '/:lang/authorization/otp',
  selectCompany: '/:lang/company-login',
  docSign: '/:lang/document-sign',
  homePage: '/:lang/home-page',
  transferPage: '/:lang/transfer-page',
  lastOperations: '/:lang/last-operations',
  paymentOrdersPage: '/:lang/payment-orders',
  templatesPage: '/:lang/templates-page',
  newTemplate: '/:lang/templates-page/new-template',
  editTemplate: '/:lang/templates-page/edit-template',
  signedOperations: '/:lang/signed-operations',
  accountsCards: '/:lang/accounts-card',
  cardOrder: '/:lang/card-order',
  salaryPage: '/:lang/salary',
  clientProfile: '/:lang/profile',
  employeeAdd: '/:lang/add-employee',
  creditsPage: '/:lang/credits',
  depositsPage: '/:lang/deposits',
  ordersPage: '/:lang/orders',
};

export default ROUTES;
